import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Row, Col, Button, Popconfirm, Tooltip } from 'antd';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import Selectors from '../../selectors';
import Actions from '../../action';

import AffiliateCommissionProfilePresentational from './affiliate-commission-profiles-presentational';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const AffiliateCommissionProfileFunctional = ({
	history,
	getAffiliateByIDCommissionProfile,
	affiliateByIDCommissionProfileLoading,
	affiliateByIDCommissionProfileData,
	userDetails,
	deleteAffiliateByIDCommissionProfile,
	deleteAffiliateByIDCommissionProfileLoading,
}) => {
	const { id, affiliateId } = useParams();
	const columns = [
		{
			title: 'Campaign',
			dataIndex: 'campaignName',
			key: 'campaignName',
			width: '35%',
			align: 'left',
			// sorter: (a, b) => a.company.localeCompare(b.company),
		},
		{
			title: 'CPC',
			dataIndex: 'cpcCommission',
			width: '15%',
			align: 'left',
			// sorter: (a, b) => a.customer.localeCompare(b.customer),
			key: 'customer',
		},
		{
			title: 'Step 1',
			dataIndex: 'step1Commission',
			width: '15%',
			align: 'left',
			// sorter: (a, b) => a.order.localeCompare(b.order),
		},
		{
			title: 'Step 2',
			dataIndex: 'step2Commission',
			width: '15%',
			align: 'left',
			// sorter: (a, b) => a.product.localeCompare(b.product),
			key: 'product',
		},
		{
			title: '',
			dataIndex: 'title',
			width: '20%',
			align: 'left',
			key: 'title',
			render: (value, row) => {
				return (
					<Row justify="center">
						<Col className="action_square_edit">
							<Tooltip placement="top" title={'Edit'}>
								<Button
									className="edit_btn"
									onClick={() => history.push(`/campaign/edit-campaign/${id}`, { detail: row })}
									icon={<EditOutlined />}
								/>
							</Tooltip>
						</Col>
						<Col className="action_square_transfer">
							<Popconfirm
								placement="topRight"
								title={`Do you want to remove affiliates from ${row.campaignName} campaign?`}
								onConfirm={() => deleteCampaign(row)}
								okText="Yes"
								cancelText="No">
								<Tooltip placement="top" title={'Delete'}>
									<Button className="commission_delete_btn" icon={<DeleteOutlined />} />
								</Tooltip>
							</Popconfirm>
						</Col>
					</Row>
				);
			},
		},
	];

	const deleteCampaign = ({ campaignId, sourceId }) => {
		const { authKey, companyId } = userDetails;
		const request = {
			authKey,
			companyId,
			sourceId,
			campaignId,
		};
		deleteAffiliateByIDCommissionProfile(request, history);
	};

	useEffect(() => {
		getAffiliateByIDCommissionProfile(id);
	}, []);

	return (
		<AffiliateCommissionProfilePresentational
			affId={id}
			affiliateId={affiliateId}
			affiliateByIDCommissionProfileData={affiliateByIDCommissionProfileData}
			affiliateByIDCommissionProfileLoading={affiliateByIDCommissionProfileLoading}
			history={history}
			columns={columns}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		affiliateByIDCommissionProfileLoading: Selectors.affiliateByIDCommissionProfileLoading(state),
		deleteAffiliateByIDCommissionProfileLoading: Selectors.deleteAffiliateByIDCommissionProfileLoading(state),
		affiliateByIDCommissionProfileData: Selectors.affiliateByIDCommissionProfileData(state),
		userDetails: SelectorsApp.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAffiliateByIDCommissionProfile: (id) => dispatch(Actions.creators.getAffiliateByIDCommissionProfile(id)),
		deleteAffiliateByIDCommissionProfile: (request, history) => dispatch(Actions.creators.deleteAffiliateByIDCommissionProfile(request, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AffiliateCommissionProfileFunctional);

export default Connected;
